export interface Response<T> {
  serverTime?: number;
  serverTimeMs?: number;
  success: true;
  errorMsg?: string;
  errorCode?: number;
  result?: T;
}

export type Result<T = any> = Promise<Response<T>>;

export const mockResponse = async (data: any) => {
  return {
    success: true,
    result: data,
  } as any;
};
